import React from 'react';

import { Icon, Text, TextInput } from 'shell/components';

const TextInputDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>TextInput</Text>
            <TextInput placeholder={'Placeholder'} />
            <TextInput error placeholder={'Placeholder'} />
            <TextInput disabled placeholder={'Placeholder'} />
            <TextInput placeholder={'Placeholder'} startIcon={<Icon kind={'locationEmpty'} />} />
            <TextInput endIcon={<Icon kind={'search'} />} placeholder={'Placeholder'} />
            <TextInput id={'textinput-demo-1'} label={'Form label'} placeholder={'Placeholder'} />
            <TextInput id={'textinput-demo-2'} label={'Form label'} placeholder={'Placeholder'} required />
            <TextInput
                id={'textinput-demo-3'}
                helperText={'Assistive Text'}
                label={'Form label'}
                placeholder={'Placeholder'}
            />
            <TextInput
                id={'textinput-demo-4'}
                helperText={'Assistive Text'}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
            />
            <TextInput id={'textinput-demo-5'} error label={'Form label'} placeholder={'Placeholder'} />
            <TextInput id={'textinput-demo-6'} error label={'Form label'} placeholder={'Placeholder'} required />
            <TextInput
                id={'textinput-demo-7'}
                error
                helperText={'Error Message'}
                label={'Form label'}
                placeholder={'Placeholder'}
            />
            <TextInput
                id={'textinput-demo-8'}
                error
                helperText={'Error Message'}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
            />
            <TextInput id={'textinput-demo-9'} disabled label={'Form label'} placeholder={'Placeholder'} />
            <TextInput id={'textinput-demo-10'} disabled label={'Form label'} placeholder={'Placeholder'} required />
            <TextInput
                id={'textinput-demo-11'}
                disabled
                helperText={'Assistive Text'}
                label={'Form label'}
                placeholder={'Placeholder'}
            />
            <TextInput
                id={'textinput-demo-12'}
                disabled
                helperText={'Assistive Text'}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
            />
            <TextInput
                id={'textinput-demo-13'}
                endIcon={<Icon kind={'search'} />}
                label={'Form label'}
                placeholder={'Placeholder'}
            />
            <TextInput
                id={'textinput-demo-14'}
                label={'Form label'}
                placeholder={'Placeholder'}
                startIcon={<Icon kind={'locationEmpty'} />}
            />
        </>
    );
};

export default TextInputDemo;
